module.exports = __webpack_public_path__ + "img/client2.43149dd3.png";